export * from "./slot.service";
export * from "./auth.service";
export * from "./session.service";
export * from "./appointment.service";
export * from "./counsellor.service";
export * from "./note.service";
export * from "./whitelabel.service";
export * from './faqs.service';
export * from './contactUs.service';



// WEBPACK FOOTER //
// ./src/services/index.js